import { IApiEvent, IEvent, IEventCategory } from '@/common/interfaces/events.interface';
import { TEventCategoryCode } from '@/common/types/events.type';

export default class EventsHelper {
  public static transformApiEventCategoryToEventCategory(apiCategory: TEventCategoryCode): IEventCategory {
    let name = ``;
    switch(apiCategory) {
      case `LM`:
        name = `Leadership Meeting`;
        break;
      case `RCG`:
        name = `RINGANA Convention`;
        break;
      case `RNX`:
        name = `RINGANA Next`;
        break;
      case `RUN3`:
        name = `RUN3`;
        break;
      case `RUN5`:
        name = `RUN5`;
        break;
      case `RUN7`:
        name = `RUN7`;
        break;
      case `RUN10`:
        name = `RUN10`;
        break;
      case `RUNM`:
        name = `MASTER RUN`;
        break;
      default:
    }
    return {
      code: apiCategory,
      name,
      selected: false,
    };
  }

  public static transformApiEventCategoriesToEventCategories(apiCategories: TEventCategoryCode[]): IEventCategory[] {
    return apiCategories.map(apiCategory => EventsHelper.transformApiEventCategoryToEventCategory(apiCategory));
  }

  public static transformApiEventToEvent(apiEvent: IApiEvent): IEvent {
    return {
      categories: EventsHelper.transformApiEventCategoriesToEventCategories(apiEvent.categories),
      endDate: apiEvent.endDate,
      eventId: apiEvent.eventId,
      link: apiEvent.link,
      location: apiEvent.location,
      registrationPossible: apiEvent.registrationPossible,
      startDate: apiEvent.startDate,
      title: apiEvent.title,
    };
  }

  public static transformApiEventsToEvents(apiEvents: IApiEvent[]): IEvent[] {
    return apiEvents.map(apiEvent => EventsHelper.transformApiEventToEvent(apiEvent));
  }
}
